(() => {
  const isTouch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;

  function closeModal(modal) {
    // Shopify/Dawn: product-modal ist ein Custom Element; "open" entfernen schließt i. d. R. zuverlässig
    modal.removeAttribute("open");

    // Fallback: Close-Button klicken, falls Theme intern darauf hört
    const btn = modal.querySelector('button[id^="ModalClose-"], .product-media-modal__toggle');
    if (btn) btn.click();
  }

  function init() {
    if (!isTouch) return;

    document.querySelectorAll("product-modal.product-media-modal").forEach((modal) => {
      // Tap auf Overlay/Backdrop -> schließen
      modal.addEventListener("click", (e) => {
        if (!modal.hasAttribute("open")) return;

        // Schließe, wenn man auf den Hintergrund oder auf ein Bild tippt
        const clickedImage = e.target.closest("img");
        const clickedBackdrop = e.target.classList.contains("product-media-modal") || e.target === modal;

        if (clickedImage || clickedBackdrop) {
          e.preventDefault();
          e.stopPropagation();
          closeModal(modal);
        }
      }, true);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
